import { OAuth2 } from '@backstage/core-app-api';
import { SignInPage } from '@backstage/core-components';
import {
  BackstageIdentityApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
  configApiRef as legacyConfigApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  configApiRef,
  createApiRef,
  createFrontendModule,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

export const authentikAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>().with({ id: 'auth.authentik' });

const authentikAuthApi = ApiBlueprint.make({
  name: 'authentik',
  params: defineParams =>
    defineParams({
      api: authentikAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            // This ID must stay "oidc" for Backstage's generic OIDC backend.
            id: 'oidc',
            title: 'Authentik',
            icon: () => null,
          },
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const environment =
        useApi(legacyConfigApiRef).getOptionalString('auth.environment');
      if (environment === 'development' || environment === 'recovery') {
        return <SignInPage {...props} providers={['guest']} />;
      }
      return (
        <SignInPage
          {...props}
          provider={{
            id: 'authentik-auth-provider',
            title: 'Authentik',
            message: 'Sign in using Authentik',
            apiRef: authentikAuthApiRef,
          }}
        />
      );
    },
  },
});

export const authentikAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [authentikAuthApi, signInPage],
});
